import { useUserData } from '@/services/user';
import { AvatarProps as ChakraAvatarProps } from '@chakra-ui/react';
import styleguide from '@common/styleguide';
import { FC } from 'react';
import Avatar from './Avatar';

const UserAvatar: FC<ChakraAvatarProps> = (props) => {
    const { userInfo } = useUserData();

    return userInfo?.avatar ? (
        <Avatar avatar={userInfo?.avatar} {...props} />
    ) : (
        <Avatar
            firstName={userInfo?.preferredName ?? userInfo?.firstName}
            background={styleguide.colors.blueBright}
            {...props}
        />
    );
};

export default UserAvatar;
